module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Most popular female names in the world")]), _vm._v(" "), _c('pie', {
    attrs: {
      "data": _vm.names
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.canAddAName) ? _c('button', {
    on: {
      "click": _vm.addName
    }
  }, [_vm._v("Add a name")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0098151c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/d3-components/pie-chart-local-component/index.vue
// module id = 118
// module chunks = 1